export default {
    data() {
        //改变表单数据错误隐藏
        var validateChange = (rule, value, callback) => {
            this.phone_error_display = false;
            this.error_display = false;
            callback();
        };
        return {
            phoneLoginDisable: false,
            loginDisable: false,
            captcha_token: "",
            error_display: false,
            error_meg: "",
            phone_error_display: false,
            phone_error_meg: "",
            login_way: 1,
            otherLogin_way: true,
            captchaUrl: "",
            pb_disabled: false,
            pb_show: "获取验证码",
            Form: {
                username: "",
                pwd: "",
                captcha: ""
            },
            Form_rule: {
                username: [
                    {
                        required: false,
                        validator: validateChange,
                        trigger: "change"
                    }
                ],
                pwd: [
                    {
                        required: false,
                        validator: validateChange,
                        trigger: "change"
                    }
                ],
                captcha: [
                    {
                        required: false,
                        validator: validateChange,
                        trigger: "change"
                    }
                ]
            },
            phoneLogin_Form: {
                phone: "",
                captcha: "",
                phone_captcha: ""
            },
            phoneLogin_Form_rule: {
                phone: [
                    {
                        required: false,
                        validator: validateChange,
                        trigger: "change"
                    }
                ],
                captcha: [
                    {
                        required: false,
                        validator: validateChange,
                        trigger: "change"
                    }
                ],
                phone_captcha: [
                    {
                        required: false,
                        validator: validateChange,
                        trigger: "change"
                    }
                ]
            },
        };
    },
    created: function () {
        this.get_captcha_token();
    },
    computed: {
        pbShow: {
            get() {
                console.log(this.pbshow)
                this.pb_show = this.$t('message.getVerificationCode');
                return this.$t('message.getVerificationCode')
            },
            set(val){

            }
            },
            exam_type: {
                get() {

                    if (this.$store.state.examInfo.currentExamInfo) {
                        return this.$store.state.examInfo.currentExamInfo.exam_type;
                    } else {
                        return 0;
                    }
                }
            },
            isHideReg: {
                get() {
                    if (this.$store.state.examInfo.currentExamInfo.function_module) {
                        return this.$store.state.examInfo.currentExamInfo.function_module.filter(item => {
                            return item.module_type == "registration_module";
                        })[0].selected;
                    } else {
                        return 0;
                    }
                }
            },
            domain: {
                get() {
                    if (this.$store.state.examInfo.currentExamInfo) {
                        return this.$store.state.examInfo.currentExamInfo.domain;
                    } else {
                        return 0;
                    }
                }
            }
        },
        methods: {
            //获取临时token，并且获取图片
            get_captcha_token: function () {
                this.$http.get(globalProvider.serviceUrl("ea/tt")).then(data => {
                    if (data.body.code == resultCode.Success) {
                        this.captcha_token = data.body.data;
                        this.captchaUrl =
                            serviceUrl + "ea/tt/vc/" + this.captcha_token;
                    }
                });
            },
            //仅仅获取临时token
            set_captcha_token: function () {
                this.$http.get(globalProvider.serviceUrl("ea/tt")).then(data => {
                    if (data.body.code == resultCode.Success) {
                        this.captcha_token = data.body.data;
                    }
                });
            },
            //改变登录方法
            onChangeLoginWay: function (e) {
                let el = e.currentTarget;
                if (el.getAttribute("index") != this.login_way) {
                    this.login_way = !this.login_way;
                    this.get_captcha_token();
                }
            },
            //验证手机号是否符合规则
            phoneNumber_va: function () {
                if (!/^1(3|6|9|4|5|7|8)\d{9}$/.test(this.phoneLogin_Form.phone)) {
                    this.phone_error_display = true;
                    this.phone_error_meg = "手机号错误,请重新填写";
                } else {
                    this.phone_error_display = false;
                    this.phone_error_meg = "";
                }
            },
            //普通登录
            onSubmit: function () {
                this.loginDisable = true;
                if (this.Form.captcha != "") {
                    if (this.Form.username != "" && this.Form.pwd != "") {
                        this.$http
                            .post(
                                globalProvider.serviceUrl("ea/s"),
                                {
                                    account: this.Form.username,
                                    pwd: this.Form.pwd,
                                    vc: this.Form.captcha,
                                    domain: this.$route.params.projectCode
                                },
                                {
                                    headers: {
                                        ttoken: this.captcha_token
                                    },
                                    emulateJSON: false
                                }
                            )
                            .then(data => {
                                this.loginDisable = false;
                                if (data.body.code == resultCode.Success) {
                                    if (data.body.data != null) {
                                        this.$store.commit(
                                            "setToken",
                                            data.body.data
                                        );
                                        if (this.$route.query.redirect) {
                                            this.getInfo();
                                        } else {
                                            this.$router.go(0);
                                            window.location.reload();
                                        }
                                    }
                                } else {
                                    this.get_captcha_token();
                                    if (data.body.code == resultCode.NotSuccess) {
                                        this.error_display = true;
                                        this.error_meg = getErrorMessage(
                                            data.body.message
                                        );
                                    }
                                }
                            });
                    } else {
                        this.loginDisable = false;
                        this.error_display = true;
                        this.error_meg = "请输入密码和账户";
                    }
                } else {
                    this.loginDisable = false;
                    this.error_display = true;
                    this.error_meg = "请输入验证码";
                }
            },
            //手机动态码登录
            onPhoneSubmit: function () {
                this.phoneLoginDisable = true;
                if (this.phoneLogin_Form.phone_captcha != "") {
                    this.$http
                        .post(
                            globalProvider.serviceUrl("ea/ta/mu"),
                            {
                                mb: this.phoneLogin_Form.phone,
                                dc: this.phoneLogin_Form.phone_captcha,

                            },
                            {
                                headers: {
                                    ttoken: this.captcha_token
                                },
                                emulateJSON: false
                            }
                        )
                        .then(data => {
                            this.phoneLoginDisable = false;
                            if (data.body.code == resultCode.Success) {
                                if (data.body.data != null) {
                                    this.$store.commit("setToken", data.body.data);
                                    if (this.$route.query.redirect) {
                                        this.getInfo();
                                    } else {
                                        this.$router.go(0);
                                        window.location.reload();
                                    }
                                }
                            } else if (data.body.code == resultCode.NotSuccess) {
                                this.phone_error_display = true;
                                this.phone_error_meg = getErrorMessage(
                                    data.body.message
                                );
                            }
                        });
                } else {
                    this.phoneLoginDisable = false;
                    this.phone_error_display = true;
                    this.phone_error_meg = "请输入手机动态验证码";
                }
            },
            getInfo: function () {
                console.log(999999999999)
                let url;
                if(this.$route.params.batchCode){
                    url ="exm_c/g/eis/{domain}/"+this.$route.params.batchCode;
                }else{
                    url = "exm_c/g/eis/{domain}";
                }
                this.$http
                    .get(globalProvider.serviceUrl(url), {
                        params: {
                            domain: this.$route.params.projectCode
                        }
                    })
                    .then(data => {
                        if (data.body.code === resultCode.Success) {
                            this.$router.push({ path: this.$route.query.redirect });
                        } else this.$router.push({ name: "default.notFound" });
                    });
            },
            //获取手机动态码
            onGetPhoneCaptcha: function () {
                if (this.phone_error_meg != "手机号错误,请重新填写") {
                    if (this.phoneLogin_Form.captcha != "") {
                        this.$http.get(
                            globalProvider.serviceUrl(
                                "ea/tt/g/mldc/ts/{phone}"
                            ),
                            {
                                params: { phone: this.phoneLogin_Form.phone },
                                headers: {
                                    ttoken: this.captcha_token
                                }
                            }
                        )
                            .then(data => {
                                if (data.body.code == resultCode.Success) {
                                    if (data.body.data < 60 && data.body.data > 0) {
                                        this.pb_disabled = true;
                                        let time = 60 - data.body.data;
                                        this.pb_show = 60 - data.body.data + 1;
                                        for (let i = 0; i <= time; i++) {
                                            window.setTimeout(() => {
                                                --this.pb_show;
                                                if (this.pb_show == 0) {
                                                    this.pb_show = "获取动态码";
                                                    this.pb_disabled = false;
                                                }
                                            }, i * 1000);
                                        }
                                    } else {
                                        this.$http.post(
                                            globalProvider.serviceUrl(
                                                "ea/tt/c/mldc"
                                            ),
                                            {
                                                mb: this.phoneLogin_Form.phone,
                                                vc: this.phoneLogin_Form.captcha,
                                                kv: {
                                                    "考试名称": this.$store.state.examInfo.currentExamInfo.exam_name
                                                }
                                            },
                                            {
                                                headers: {
                                                    ttoken: this.captcha_token
                                                },
                                                emulateJSON: false
                                            }
                                        )
                                            .then(data => {
                                                if (
                                                    data.body.code == resultCode.Success
                                                ) {
                                                    this.pb_disabled = true;
                                                    let time = 60;
                                                    this.set_captcha_token();
                                                    this.pb_show = time + 1;
                                                    for (
                                                        let i = 0;
                                                        i <= time;
                                                        i++
                                                    ) {
                                                        window.setTimeout(() => {
                                                            this.pb_show =
                                                                this.pb_show - 1;
                                                            if (this.pb_show == 0) {
                                                                this.pb_show =
                                                                    "重新发送";
                                                                this.pb_disabled = false;
                                                                this.captchaUrl =
                                                                    serviceUrl +
                                                                    "ea/tt/vc/" +
                                                                    this
                                                                        .captcha_token;
                                                            }
                                                        }, i * 1000);
                                                    }
                                                } else if (
                                                    data.body.code ==
                                                    resultCode.NotSuccess
                                                ) {
                                                    this.get_captcha_token();
                                                    this.phone_error_display = true;
                                                    this.phone_error_meg = getErrorMessage(
                                                        data.body.message
                                                    );
                                                } else {
                                                    this.get_captcha_token();
                                                }
                                            });
                                    }
                                } else if (
                                    data.body.code == resultCode.NotSuccess
                                ) {
                                    this.phone_error_display = true;
                                    this.phone_error_meg = getErrorMessage(
                                        data.body.message
                                    );
                                }
                            });
                    } else {
                        this.phone_error_display = true;
                        this.phone_error_meg = "请输入验证码";
                    }
                }
            }
        }
    };